import { Component, OnInit, Inject  } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { GestionService } from 'src/app/services/gestion.services';
import { BrokerService } from 'src/app/services/broker.services';
import { SuscripcionesService } from 'src/app/services/suscripciones.service';
import { CarteraOptimaParamsService } from 'src/app/services/cartera-optima-params.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';
import { TemaService } from 'src/app/services/tema.services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-reconfiguracion-dialog',
  templateUrl: './reconfiguracion-dialog.component.html',
  styleUrl: './reconfiguracion-dialog.component.scss'
})
export class ReconfiguracionDialogComponent implements OnInit {
  public isBroker: boolean =false;
  public guardando: boolean = false;
  public sincronizando: boolean = false;
  // CSV de idcarteraoptima (uno por subcartera) de la suscripción de esta cartera
  public idsCarteraOptima: string = '';

  public optimalWalletreconfi: OptimalWallet;
  public licencia: string;
  purchaseTypes: string[] = [
    'LIMITADO',
    'FIJO'
  ];
  accountType: string[] = [
    'MARGEN',
    'NOMINAL'
]
  constructor(public dialogRef: MatDialogRef<ReconfiguracionDialogComponent>,
              private _dialog: MatDialog,
              private _gestionsv: GestionService,
              private _brokersv: BrokerService,
              private _cookieService: CookieService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private _sseservice: SseService,
              private _suscripcionesService: SuscripcionesService,
              private _carteraOptimaParamsService: CarteraOptimaParamsService,
              private _toastr: ToastrService,
              private _temaService: TemaService){

  }
  ngOnInit(): void {
    this.licencia = this._cookieService.get('auth_token');
      this.optimalWalletreconfi = this.data.optimaWallet;
      this.isBroker = this.data.isBroker;
      this.cargarIdsCarteraOptima();
  }

  // Solo carteras con suscripción: su idcarteraoptima (uno por subcartera) sale de la suscripción
  private cargarIdsCarteraOptima() {
    const idcarterasuscrita = Number(this.data.idcarterasuscrita) || 0;
    if (idcarterasuscrita <= 0) return;
    this._suscripcionesService.listarSuscripcionesConfirmar('').subscribe({
      next: (value: any[]) => {
        const suscripcion = (value || []).find((s: any) => s.idcartera === idcarterasuscrita);
        if (suscripcion?.idcarteraoptima) this.idsCarteraOptima = String(suscripcion.idcarteraoptima);
      },
      error: err => console.error('Error consultando la suscripción de la cartera', err)
    });
  }

  tieneCarteraOptima(): boolean {
    return this.idsCarteraOptima.split(',').some(id => Number(id.trim()) > 0);
  }

  // Solo rellena el formulario con los parámetros de la cartera óptima; se guarda con Aceptar
  sincronizarOptima() {
    if (this.sincronizando || !this.tieneCarteraOptima()) return;
    this._temaService.valDarkTheme.pipe(take(1)).subscribe(isDark => this.confirmarSincronizacion(isDark ? 'dark-theme' : 'light-theme'));
  }

  private confirmarSincronizacion(panelClass: string) {
    const confirmRef = this._dialog.open(ConfirmDialogComponent, {
      width: '380px',
      panelClass,
      data: {
        titulo: 'Sincronizar cartera óptima',
        icon: 'sync',
        msj: 'Se cargarán en el formulario los parámetros de la cartera óptima de la suscripción (capital, apalancamiento, riesgo, márgenes y costes). No se guardará nada hasta pulsar Aceptar.',
        botonAceptar: 'Sincronizar',
        botonCancelar: 'Volver',
      }
    });
    confirmRef.afterClosed().subscribe(ok => {
      if (ok) this.aplicarCarteraOptima();
    });
  }

  private aplicarCarteraOptima() {
    this.sincronizando = true;
    this._carteraOptimaParamsService.sincronizarDesdeOptimas(this.optimalWalletreconfi, this.idsCarteraOptima).subscribe({
      next: res => {
        this.sincronizando = false;
        if (res.aplicadas === 0) {
          this._toastr.error('No se pudieron cargar los parámetros de la cartera óptima');
          return;
        }
        this._toastr.info('Valores cargados desde la cartera óptima. Revisa y pulsa Aceptar para guardar.');
        if (res.riesgoMixto) {
          this._toastr.warning('Las subcarteras tienen distinto riesgo; se mantiene el riesgo actual de la cartera');
        }
      },
      error: err => {
        console.error('Error sincronizando con la cartera óptima', err);
        this.sincronizando = false;
        this._toastr.error('Ocurrió un error sincronizando con la cartera óptima');
      }
    });
  }
  calcularData(){
    this.optimalWalletreconfi.efectivo = this.optimalWalletreconfi.capitalinicial;
    this.optimalWalletreconfi.valorLiquidativo = this.optimalWalletreconfi.capitalinicial;
    this.optimalWalletreconfi.fondosDisponibles = this.optimalWalletreconfi.capitalinicial;
    this.optimalWalletreconfi.poderCompra = this.optimalWalletreconfi.capitalinicial * this.optimalWalletreconfi.apalancamiento;
  }

  esNominal(): boolean {
    return this.optimalWalletreconfi.tipocuenta === 'NOMINAL';
  }

  esValido(): boolean {
    const w = this.optimalWalletreconfi;
    return w.capitalinicial > 0
      && w.apalancamiento >= 1
      && w.riesgo != null
      && w.stopLoss != null;
  }

  guardar(){
      if (this.guardando || !this.esValido()) return;
      this.guardando = true;
      this._sseservice.apiPostNew('actualizarcartera',this.optimalWalletreconfi,this.licencia).subscribe({
        next: response => {
          if(this.isBroker){
            this._brokersv.updateBrokOptimaWallet(response);
            this._brokersv.updateactualizarCarteraBroker(true);
          }else{
            this._gestionsv.updategestOptimaWallet(response);
            this._gestionsv.updateactualizarCartera(true);
          }
          this.dialogRef.close();
        },
        error: err => {
          console.error('Error al reconfigurar la cartera', err);
          this.guardando = false;
        }
      });

  }
  validateStopLoss() {
    if (this.optimalWalletreconfi.stopLoss < 0.001) {
      this.optimalWalletreconfi.stopLoss = 0.001;
    } else if (this.optimalWalletreconfi.stopLoss > 100) {
      this.optimalWalletreconfi.stopLoss = 100;
    }
  }
  onTipoCuentaChange() {
    this.optimalWalletreconfi.apalancamiento = this.esNominal() ? 1 : 2;
    this.calcularData();
  }
}
